import { useEffect } from 'react';
import { useDateProgress } from '../../hooks/useDateProgress';
import { useAppDispatch } from '../../store';
import { getPurchases } from '../../store/reducers/store/asyncActions';
import { TInGameStoreItem } from '../../types';
import getBoosterIcon from '../utils/getBoosterIcon';

type ActiveBoosterCardProps = {
    purchase: TInGameStoreItem
    onBoosterClick: () => void
}
function ActiveBoosterCard({ purchase, onBoosterClick }: ActiveBoosterCardProps) {
  const dispatch = useAppDispatch();

  const { remain, isFinished, start } = useDateProgress();

  const handleClick = () => {
    onBoosterClick();
  };

  const handleTimerEnd = () => {
    dispatch(getPurchases());
  };

  const BoosterIcon = getBoosterIcon(purchase.store_item_level.store_item.icon);

  useEffect(() => {
    start(new Date().getTime(), new Date(purchase?.expires_at ?? 0).getTime());
  }, []);

  useEffect(() => {
    if (isFinished) {
      handleTimerEnd();
    }
  }, [isFinished]);

  if (isFinished) {
    return null;
  }

  return (
    <div className="flex flex-col items-center max-w-[60px]" onClick={handleClick}>
      <img src={BoosterIcon} alt="booster-icon" className="w-[45px] h-[45px]" />
      <div className="font-Bangers text-xs uppercase leading-[12.77px]">
        {purchase.store_item_level.store_item.name}
      </div>
      <div className="font-Barlow text-xs uppercase leading-[12px]">
        {(purchase.store_item_level.store_item.type === 'temporary' && purchase.expires_at)
        && <Timer formatedMinutes={remain.formatedMinutes} formatedSecond={remain.formatedSecond} />}
      </div>
    </div>
  );
}

export default ActiveBoosterCard;

type TimerProps = {
  formatedSecond: string, formatedMinutes: string;
}
function Timer({ formatedSecond, formatedMinutes }: TimerProps) {
  return (
    <div>
      <span>
        {formatedMinutes}
      </span>
      :
      <span>
        {formatedSecond}
      </span>
    </div>
  );
}
